import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../hooks/usePageTitle';
import useCanonicalTag from '../hooks/useCanonicalTag';
import useMetaTags from '../hooks/useMetaTags';
import '../styles/fonts.css';

function Terms() {
  const { t } = useTranslation();
  usePageTitle('Termos de Uso');
  useCanonicalTag();
  useMetaTags({ title: 'Termos de Uso | Celeritas', url: 'https://celeritas.live/termos' });
  const s = { fontSize: '14px', lineHeight: '1.7', color: '#8b949e' };
  const li = { fontSize: '14px', lineHeight: '1.9', color: '#8b949e', paddingLeft: '20px', marginTop: '8px' };
  const h2 = { fontSize: '17px', fontWeight: 600, color: '#e6edf3', marginBottom: '10px' };

  return (
    <div style={{ minHeight: '100vh', background: '#1b1f23', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1, maxWidth: '800px', margin: '0 auto', padding: '48px 24px', color: '#c9d1d9' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px', color: '#fff' }}>{t('terms.title')}</h1>
        <p style={{ fontSize: '13px', color: '#8b949e', marginBottom: '40px' }}>{t('terms.lastUpdated')}</p>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s1_title')}</h2>
          <p style={s}>{t('terms.s1_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s2_title')}</h2>
          <p style={s}>{t('terms.s2_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s3_title')}</h2>
          <p style={s}>{t('terms.s3_text')}</p>
          <ul style={li}>
            <li>{t('terms.s3_li1')}</li>
            <li>{t('terms.s3_li2')}</li>
            <li>{t('terms.s3_li3')}</li>
            <li>{t('terms.s3_li4')}</li>
          </ul>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s3b_title')}</h2>
          <p style={s}>{t('terms.s3b_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s4_title')}</h2>
          <p style={s}>{t('terms.s4_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s5_title')}</h2>
          <p style={s}>{t('terms.s5_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s6_title')}</h2>
          <p style={s}>{t('terms.s6_text')}</p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{t('terms.s7_title')}</h2>
          <p style={s}>{t('terms.s7_text')}</p>
        </section>

        <section>
          <h2 style={h2}>{t('terms.s8_title')}</h2>
          <p style={s}>
            {t('terms.s8_text')}{' '}
            <a href="https://discord.gg/mR45gCfark" target="_blank" rel="noopener noreferrer"
               style={{ color: '#5865F2', textDecoration: 'none' }}>{t('terms.s8_discord')}</a>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Terms;
